module.exports = __webpack_public_path__ + "static/flags/CJ-a52d01e40435787bc8d77124eb467e7e.gif";